export default "__VITE_ASSET__701725a5__"